var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let MoveSubjectDialog = class MoveSubjectDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedArea = null;
        this.selectedTopic = null;
    }
    mounted() {
        //
    }
    close() {
        this.$emit('input', false);
    }
    onAreaChanged() {
        this.selectedTopic = null;
    }
    onConfirm() {
        const subject = this.depth === 0 ? this.selectedArea : this.selectedTopic;
        this.$emit('confirm', subject);
        this.close();
    }
    get canSelectTopic() {
        return !!(this.selectedArea && this.selectedArea.children && this.selectedArea.children.length && this.depth === 1);
    }
    get canConfirm() {
        return !!((this.depth === 0 && this.selectedArea)
            || (this.depth === 1 && this.selectedTopic));
    }
};
__decorate([
    Prop({ default: [] }),
    __metadata("design:type", Array)
], MoveSubjectDialog.prototype, "areas", void 0);
__decorate([
    Prop({ default: 0 }),
    __metadata("design:type", Number)
], MoveSubjectDialog.prototype, "depth", void 0);
MoveSubjectDialog = __decorate([
    Component({})
], MoveSubjectDialog);
export default MoveSubjectDialog;
